import { Page } from "src/Page";
import { RootAction } from "src/types";

function page(state: Page = "login", action: RootAction): Page {
  switch (action.type) {
    case "CHANGE_PAGE":
      return action.payload;
    case "AUTH_STATE_CHANGED":
      if (action.payload) {
        return "user_list";
      } else {
        return "login";
      }
    default:
      return state;
  }
}

export default page;



// WEBPACK FOOTER //
// ./src/reducers/pageReducer.ts